import styled, { css } from "styled-components";
import { useState } from "react";
// icons
import { BsMap, BsChatDots } from "react-icons/bs"
import { FaPersonWalkingLuggage } from 'react-icons/fa6'
import { MdOutlineSell, MdOutlineAdminPanelSettings, MdPlace} from 'react-icons/md'
import { IoPersonCircleOutline } from 'react-icons/io5'
import { Link } from "react-router-dom";
import { TbSteeringWheel } from "react-icons/tb";
import { GiHiking } from "react-icons/gi";
import { IoTicketOutline } from "react-icons/io5";
import { IoIosAirplane } from "react-icons/io";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaHandsHelping } from "react-icons/fa";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { FaSalesforce } from "react-icons/fa6";
import { IoCarSportSharp } from "react-icons/io5";
import { FaCoins } from "react-icons/fa";
import { FaCodePullRequest } from "react-icons/fa6";
import { GiCash } from "react-icons/gi";
import { BsCalendar2Week } from "react-icons/bs";
import { LuMerge } from "react-icons/lu";
// utils
import toQuery from "../../utils/toQuery";
// context
import { useAdmin } from "../../context/admin";
// superowner sidebar
import SidebarList from "./superowner/SidebarList";
import { mobile } from "../../styles/responsive";

export default function Sidebar() {
    const { tab, user, currentDay, endDay, sellerId } = useAdmin()
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

    // Helper function to preserve query params when navigating
    const getLinkParams = (newTab: string) => {
        const params: any = { tab: newTab };
        
        // Preserve currentDay
        if (currentDay) {
            params.currentDay = currentDay.toISOString();
        }
        
        // Preserve endDay if it exists
        if (endDay) {
            params.endDay = endDay.toISOString();
        }
        
        // Preserve sellerId if it exists
        if (sellerId) {
            params.sellerId = sellerId;
        }
        
        return toQuery(params);
    };

    return (
        <Main isSidebarOpen={isSidebarOpen}>
            <Tabs isSidebarOpen={isSidebarOpen}>
                <div className={`${tab === 'tours' && 'selected'}`}>
                    <Link to={`/admin${getLinkParams('tours')}`}>
                            <BsMap/>
                            <span>
                                Tours
                            </span>
                    </Link>
                </div>
                {
                    user?.user.source !== 'superowners' &&
                    <>
                    <div className={`${tab === 'bot' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('bot')}`} >
                            <BsChatDots/>
                            <span>
                                Bot Web
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'reservations' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('reservations')}`} >
                            <IoTicketOutline/>
                            <span>
                                Reservations
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'trips' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('trips')}`} >
                            <IoIosAirplane/>
                            <span>
                                Trips
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'traspass' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('traspass')}`} >
                            <FaHandsHelping/>
                            <span>
                                Traspass
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'sales' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('sales')}`} >
                            <FaSalesforce/>
                            <span>
                                Sales
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'authorizations' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('authorizations')}`} >
                            <FaCodePullRequest/>
                            <span>
                                Authorizations
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'cars' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('cars')}`} >
                            <IoCarSportSharp/>
                            <span>
                                Cars
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'costs' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('costs')}`} >
                            <FaCoins/>
                            <span>
                                Costs
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'caja' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('caja')}`} >
                            <GiCash/>
                            <span>
                                Caja
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'turnos' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('turnos')}`} >
                            <BsCalendar2Week/>
                            <span>
                                Turnos
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'zones' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('zones')}`} >
                            <MdPlace/>
                            <span>
                                Zones
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'passengers' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('passengers')}`} >
                            <FaPersonWalkingLuggage/>
                            <span>
                                Passengers
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'drivers' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('drivers')}`} >
                            <TbSteeringWheel/>
                            <span>
                                Drivers
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'guiders' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('guiders')}`} >
                            <GiHiking/>
                            <span>
                                Guiders
                            </span>
                        </Link>
                    </div>
                    </>
                }
                {
                    user?.user.source === 'superowners' &&
                    <SidebarList/>
                }
                {
                    user?.user.source === 'agencies' &&
                    <>
                    <div className={`${tab === 'sellers' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('sellers')}`} >
                            <MdOutlineSell/>
                            <span>
                                Sellers
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'allies' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('allies')}`} >
                            <LuMerge/>
                            <span>
                                Allies
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'admins' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('admins')}`} >
                            <MdOutlineAdminPanelSettings/>
                            <span>
                                Admins
                            </span>
                        </Link>
                    </div>
                    <div className={`${tab === 'earnings' && 'selected'}`}>
                        <Link to={`/admin${getLinkParams('earnings')}`} >
                            <RiMoneyDollarCircleLine/>
                            <span>
                                Earnings
                            </span>
                        </Link>
                    </div>
                    </>
                }
                <div className={`${tab === 'me' && 'selected'}`}>
                    <Link to={`/admin${getLinkParams('me')}`}>
                        <IoPersonCircleOutline/>
                        <span>
                            My profile
                        </span>
                    </Link>
                </div>
            </Tabs>
            <Close isSidebarOpen={isSidebarOpen}
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            >
                {
                    isSidebarOpen ?
                    <IoIosArrowBack/>
                    :
                    <IoIosArrowForward/>
                }
            </Close>
        </Main>
    )
}


const Main = styled.aside<{ isSidebarOpen: boolean }>`
  ${props => props.isSidebarOpen &&
    mobile({
      position: "absolute",
      zIndex: 25
    })
  }
  padding: 20px;
  background-color: ${props => props.theme.dark};
  height: 100%;
  width: fit-content;
  position: relative;
  padding-top: 50px;
`;

const Tabs = styled.div<{ isSidebarOpen: boolean }>`
  height: 100%;                     /* fill parent height */
  overflow-y: auto;                 /* enable vertical scroll when content overflows */
  overflow-x: hidden;               /* prevent horizontal scroll if any */
  padding-right: 5px;               /* optional: space for scrollbar */
  
  ${props => props.isSidebarOpen &&
    mobile({
      marginRight: '10px'
    })
  }
  ${props => !props.isSidebarOpen &&
    mobile({
      width: 0,
      overflow: 'hidden'            // hide completely when closed on mobile
    })
  }

  .selected a {
    background-color: ${props => props.theme.black};
  }

  a {
    color: ${props => props.theme.white};
    margin-bottom: 5px;
    padding: 5px 10px;
    transition: background .3s linear;
    border-radius: 5px;
    display: flex;
    align-items: center;
    gap: 5px;
    text-decoration: none;
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.black};
    }
  }
`;

/* Close button stays as is */
const Close = styled.div<{ isSidebarOpen: boolean }>`
  cursor: pointer;
  display: none;
  ${mobile({
    display: 'flex'
  })}
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 100%;
  background-color: ${props => props.theme.dark};
  color: ${props => props.theme.white};
  overflow: hidden;
  justify-content: center;
  align-items: center;
`;